import { render, staticRenderFns } from "./Unilateral-chart.vue?vue&type=template&id=642b8c84&scoped=true&"
import script from "./Unilateral-chart.vue?vue&type=script&lang=js&"
export * from "./Unilateral-chart.vue?vue&type=script&lang=js&"
import style0 from "./Unilateral-chart.vue?vue&type=style&index=0&id=642b8c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b8c84",
  null
  
)

export default component.exports